import { render, staticRenderFns } from "./DormerPlacementRadioField.vue?vue&type=template&id=58fe70de"
import script from "./DormerPlacementRadioField.vue?vue&type=script&lang=js"
export * from "./DormerPlacementRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports